const OverdraftDetails = {
  data: {
    pageTitle: 'Cheque Especial',
    components: [
      // {
      //   componentType: 'LIMIT_USED',
      //   // icon: 'attention',
      //   title: 'Limite excedido ',
      //   description: 'Negocie seu contrato de cheque especial para manter seu saldo em dia.',
      //   actionOptions: [
      //     // {
      //     //   title: 'Regularizar saldo',
      //     //   type: 'REGULARIZE_BALANCE',
      //     //   actionUrl: 'deeplink-to-anywhere',
      //     //   actionVariant: 'primary',
      //     // },
      //     {
      //       title: 'Negociar',
      //       type: 'NEGOTIATE',
      //       actionUrl: 'deeplink-to-anywhere2',
      //       actionVariant: 'primary',
      //     },
      //   ],
      // },

      {
        actionOptions: [
          {
            title: 'Depositar via pix',
            actionUrl: 'bancointer://pix/receber',
            type: 'DEPOSIT_BY_PIX',
            variant: 'primary',
          },
        ],
        title: 'Limite total utilizado',
        icon: 'attention',
        description: 'Realize o depósito em conta para manter seu saldo em dia.',
        componentType: 'LIMIT_USED',
      },

      {
        componentType: 'BOX_HIDDEN',
        boxOptions: [
          {
            title: 'Saldo em Conta',
            value: 'R$ 203.905.278,75',
          },
          {
            title: 'Saldo+Cheque Especial',
            value: 'R$ 203.905.678,75',
          },
        ],
      },
      {
        componentType: 'CONDITIONAL_BOX',
        icon: 'credit',
        title: 'Aumente seu limite para R$ 1.250,69',
        description: 'Clique aqui para aumentar seu limite',
        showBottomsheetOnStartup: false,
        bottomsheet: [
          {
            componentType: 'SINGLE_ICON',
            icon: 'credit',
            status: 'DEFAULT',
          },
          {
            componentType: 'LIST_OPTIONS',
            title: 'Novo limite pré-aprovado de \nR$ 1.250,00',
            description:
              'Seu Cheque Especial tem um novo limite. Aceite o termo de adesão para começar a contar com mais esta vantagem!',
          },
          {
            componentType: 'CONTRACT_ADHESION',
            title: 'Li e concordo com as informações descritas no documento Termo de adesão {}',
            action: 'Termo de adesão.',
            actionUrl:
              'https://bkt-prd-projetos.s3.amazonaws.com/open_finance/termos/TRANSMISSORA_POLITICA_DE_PRIVACIDADE.pdf',
          },
        ],
      },
      {
        componentType: 'BOX_INFO',
        title: 'Você é elegível a 10 Dias sem Juros',
        description: 'Use o limite até o último dia do benefício no mês e fique isento de juros',
      },
      {
        componentType: 'PROGRESS_BAR_WITH_DETAILS',
        details: [
          {
            leftTitle: 'Utilizado',
            leftValue: 'R$ 1.000,00',
            rightTitle: 'Disponível',
            rightValue: 'R$ 9.000,00',
            progressPercentage: '12.9%',
          },
        ],
      },
      {
        componentType: 'LIST_OPTIONS',
        title: 'Detalhes da utilização',
        options: [
          {
            title: 'Data da renovação do limite',
            value: 'xx/xx/xxxx',
          },
          {
            title: 'Limite contratado',
            value: 'R$ 3.000,00',
          },
        ],
      },
      {
        componentType: 'WARNING',
        title: 'É importante saber',
        description:
          'O valor referente ao uso do Cheque Especial será proporcional ao tempo de utilização e cobrado no 1º dia útil do mês seguinte.',
      },
      {
        componentType: 'LIST_OPTIONS',
        title: 'Taxas e juros',
        options: [
          {
            title: 'Taxa de juros mensal',
            value: '7,77%',
          },
          {
            title: 'Taxa de juros anual',
            value: '92,4%',
          },
          {
            title: 'IOF',
            value: '0,62%',
          },
          {
            title: 'IOF adicional',
            value: '0,00137%',
          },
          {
            title: 'CET (custo efetivo total) mensal',
            value: '8,32%',
          },
          {
            title: 'CET (custo efetivo total) anual',
            value: '99,32%',
          },
        ],
      },
      {
        componentType: 'ACTION',
        title: 'Ações',
        actionOptions: [
          {
            title: 'Termo de adesão',
            icon: 'download',
            type: 'DOWNLOAD_TERMS',
            actionUrl:
              'https://bkt-prd-projetos.s3.amazonaws.com/open_finance/termos/TRANSMISSORA_POLITICA_DE_PRIVACIDADE.pdf',
          },
          {
            title: 'Baixar descritivo de crédito',
            icon: 'download',
            type: 'DOWNLOAD_CREDIT',
          },
          {
            title: 'Cancelar',
            icon: 'canceled',
            type: 'REDIRECT_CANCEL',
          },
          {
            title: 'Alterar limite',
            icon: 'canceled',
            type: 'REDIRECT_CHANGE_LIMITS',
          },
        ],
      },
    ],
  },
}

const OverdraftDetailsNewContract = {
  data: {
    pageTitle: 'Cheque Especial',
    components: [
      {
        componentType: 'MESSAGE_STATUS',
        icon: 'checkCircle',
        type: 'ERROR',
        title: 'Contrato já assinado...',
        description:
          'Estamos processando seu contrato de Cheque Especial e seu limite será liberado em até 24 horas...',
      },
    ],
  },
}

const OverdraftDetailsPromiseAgreement = {
  data: {
    pageTitle: '',
    components: [
      {
        componentType: 'MESSAGE_STATUS',
        icon: 'checkCircle',
        type: 'SUCCESS',
        title: 'Negociação em andamento',
        description: 'Acompanhe a gestão das cobranças pela nossa central de atendimento.',
        actionOptions: [
          {
            title: 'Entendi',
            type: 'REDIRECT_SUPER_APP',
            actionUrl: 'deeplink_to_anywhere1',
            actionVariant: 'primary',
          },
          {
            title: 'Ir para atendimento',
            type: 'REDIRECT_SERVICE',
            actionUrl: 'deeplink_to_anywhere2',
            actionVariant: 'secondary',
          },
        ],
      },
    ],
  },
}

export { OverdraftDetails, OverdraftDetailsNewContract, OverdraftDetailsPromiseAgreement }
